module.exports = __webpack_public_path__ + "img/51626518_L.a94d6b7a.png";